import React from 'react';
import AddGame from '../../components/games/new-game';

const NewGameContainer = () => {
    return <AddGame />;
};

export default NewGameContainer;
